import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { semanticColors } from "../theme/tokens";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

/**
 * Canonical primary title for ordinary rows and card headers.
 * 15px / 18px / 600 keeps the title readable without turning every
 * supporting surface into a display heading.
 */
export function PrimaryTitleText({ children, numberOfLines, style }: Props) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          flexShrink: 1,
          fontSize: 15,
          lineHeight: 18,
          color: semanticColors.typography.primary,
          fontWeight: "600",
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export default PrimaryTitleText;
